import React from 'react';
import withRoot from './modules/withRoot';
import { UI_BASE_URL } from './consts';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import ExamResultOfOrg from './modules/components/ExamResultOfOrg';



const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <ExamResultOfOrg
            path={UI_BASE_URL} // TODO: change
        />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);
